import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import '../App.css';

const BooksPreview: React.FC = () => {
  const [imgFailed, setImgFailed] = useState(false);

  return (
    <div className="preview-page">
      <div className="preview-split">
        <div className="preview-copy">
          <p className="preview-eyebrow">My Books</p>
          <h2 className="preview-headline">Your manuscript library, always within reach.</h2>
          <p className="preview-body">
            Upload your writing from the Chaptery desktop app and see every book, chapter,
            and revision in one place. Track your progress, manage series, and sync across
            all your devices.
          </p>
          <ul className="preview-bullets">
            <li>Cloud-synced book library</li>
            <li>Full revision history</li>
            <li>Series and chapter organisation</li>
            <li>Cover art and metadata</li>
          </ul>
          <Link to="/pricing" className="btn-primary">Subscribe to unlock →</Link>
        </div>

        <div className="preview-image">
          {!imgFailed && (
            <img
              src="/img/books-preview.png"
              alt="The My Books library: cover art, word counts, and a revision dropdown open on one book"
              onError={() => setImgFailed(true)}
            />
          )}
          {imgFailed && (
            <div className="preview-image-placeholder">
              <span>📚</span>
              <p>Screenshot coming soon</p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default BooksPreview;
